<template>
  <div id="app">
    <app-navigation />
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view></router-view>
  </div>
</template>

<script>
import AppNavigation from './components/navigation/AppNavigation.vue'

export default {
  components: {
    AppNavigation
  }
}
</script>

<style>
#app {
  font-family: 'Asap', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 400;
  text-align: center;
  letter-spacing: -.15px;
  color: #000812;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: white;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0 0 5px 0;
  font-family: 'Asap', sans-serif;
  font-weight: 700;
}

.container {
  max-width: 1600px;
  margin: 0 auto;
  height: 100%;
  display: grid;
  grid-template-areas:
    "app-header" "app-content" "app-footer";
  grid-template-rows: auto 1fr auto;
}

.page-content-wrapper {
  display: grid;
  grid-template-areas: "page-hero" "page-content";
  grid-template-rows: auto auto;
}

.page-hero {
  grid-area: page-hero;
}

.page-content {
  grid-area: page-content;
}

a {
  text-decoration: none;
  font-weight: 600;
  color: #7b8a1d;
  cursor: pointer;
}

b {
  font-weight: 700;
}

.italics {
  font-style: italic;
}

.responsive {
  max-width: 100%;
  height: auto;
}

button {
  margin: 20px 10px;
  cursor: pointer;
}

button:disabled {
  background-color: #888;
  cursor: not-allowed;
}

/* Basic call-to-action button */
.button {
  font: inherit;
  font-weight: 700;
  background-color: #f47e20;
  color: #fff;
  /* padding: 10px 20px; */
  cursor: pointer;
  border: 1px solid #fff;
  border-radius: 5px;
  min-width: 180px;
  min-height: 40px;
  margin: 0 10px 10px 0;
}

.button:hover:enabled, .button:active {
  background-color: #ffa052;
}

.button:focus {
  outline: 0 !important;
  background-color: #e06809;
}

/* Secondary button */
.secondary {
  background-color: #fff;
  color: #26577f;
  border: 2px solid #26577f;
}

.secondary:hover,
.secondary:active,
.secondary:focus {
  background-color: #fff !important;
  color: #173955;
  border: 2px solid #173955;
}

.medium {
  padding: 10px 15px;
  min-width: auto;
  min-height: auto;
}

.small {
  padding: 5px 10px;
  font-size: .8em;
  min-width: auto;
  min-height: auto;
}

</style>
